import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRole } from '../interfaces/role';

@Injectable({
  providedIn: 'root'
})
export class RoleService {
  private rootUrl: string = "/api/roles";

  constructor(private httpClient: HttpClient) { }

  public getRoles(appId: number): Observable<IRole[]> {
    var url = this.rootUrl + "?appId=" + appId;
    return this.httpClient.get<IRole[]>(url);
  }
}
